import apiRoutes from './api.routes';
import ModelService from './model.service';

const PostCategoryService = new ModelService(apiRoutes.postsCategories, '/posts-categories', 'blog');

PostCategoryService.getImage = (filename, w = false, h = false, c = false) => PostCategoryService.getFilePathByDir('/uploads/posts', filename, w, h, c);

/** Types */
PostCategoryService.TYPE_ARTICLES = 1;
PostCategoryService.TYPE_NEWS = 2;

PostCategoryService.getTypeList = t => ({
  [PostCategoryService.TYPE_ARTICLES]: t('Blog'),
  [PostCategoryService.TYPE_NEWS]: t('News'),
});

PostCategoryService.getTypeOptions = t => PostCategoryService
  .prepareOptionsFromSimpleObject(PostCategoryService.getTypeList(t));

PostCategoryService.getTypeTitle = (status, t) => {
  const label = PostCategoryService.getTypeList(t)[status];
  return label || '-';
};

export default PostCategoryService;



// WEBPACK FOOTER //
// ./src/services/postCategory.service.js